import { render, staticRenderFns } from "./kpiDossier.vue?vue&type=template&id=37bab268&"
import script from "./kpiDossier.vue?vue&type=script&lang=js&"
export * from "./kpiDossier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports